import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import Touch from 'vuetify/lib/directives/touch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSnackbar,
    {
      directives: [
        {
          def: Touch,
          name: "touch",
          rawName: "v-touch",
          value: {
            down: _vm.handleSnackbarClose,
          },
          expression: "{\n    down: handleSnackbarClose,\n  }",
        },
      ],
      staticClass: "snackbar-notification",
      class: { "snackbar-notification_dialog": _vm.upper },
      attrs: { timeout: _vm.snackbarTimeout, value: _vm.value, color: "text" },
      on: { input: _vm.handleSnackbarToggle },
      scopedSlots: _vm._u(
        [
          _vm.actionText
            ? {
                key: "action",
                fn: function ({ attrs }) {
                  return [
                    _c(
                      VBtn,
                      _vm._b(
                        {
                          attrs: { color: "primary", text: "" },
                          on: { click: _vm.handleAction },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      [_vm._v("\n      " + _vm._s(_vm.actionText) + "\n    ")]
                    ),
                  ]
                },
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c("span", { staticClass: "text-body-2" }, [
        _vm._v("\n    " + _vm._s(_vm.message) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }